angular
  .module('company')

  .factory('ActivityCrud', [
    'Crud',

    function(Crud) {
      'use strict';

      class ActivityCrud extends Crud {
        constructor(list) {
          super(
            'activity' + (list || ''),
            '@@apiUrl' + '/activities' + (list || '') + '/:id',
            { id: '@id' },
            {
              query: {
                method: 'GET',
                isArray: true
              }
            }
          );
        }
      }

      return ActivityCrud;
    }
  ]);
